import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M144.9116 285C222.031 285 285 221.9735 285 145S222.031 5 144.9116 5C67.969 5 5 68.0265 5 145s62.969 140 139.9116 140zm-27.77-84.3884c-5.3065 3.1778-11.3204.5296-11.3204-4.9432V94.3317c0-5.473 6.1908-8.1211 11.3203-4.9433l81.5413 49.256c5.1296 3.0013 5.1296 9.8865 0 13.0644l-81.5413 48.9028z"
})), 'PlayFilledThinIcon');